<template>
  <div class="w-100">
    <div class="row">
      <div class="col-3">
        <b-form-group
            :label="$t('statistics.filter.locale')"
            label-for="locale"
        >
          <multiselect
              id="locale"
              :options="adminLocale"
              :multiple="false"
              v-model="locale"
              label="label"
              track-by="name"
              :placeholder="$t('form.statistics.placeholder.locale')"
          >
          </multiselect>
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-12 d-flex justify-content-end mb-3">
        <b-button class="btn" variant="secondary" @click="clearFilters">{{ $t('statistics.btn.clear') }}</b-button>
        <b-button class="btn ml-2" variant="primary" @click="getReport">{{ $t('statistics.btn.apply') }}</b-button>
      </div>
    </div>

    <div class="table-responsive">
      <table v-if="question && !isBusy" class="table table-striped mt-4">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">{{ $t(`table.header.statistics.question.quantity`, { locale: locale ? locale.label.toUpperCase() : '' }) }}</th>
            <th scope="col">{{ $t('table.header.statistics.question.used_at_least_one_time') }}</th>
            <th scope="col">{{ $t('table.header.statistics.question.used_more_then_once') }}</th>
            <th scope="col">{{ $t('table.header.statistics.question.max_usage') }}</th>
          </tr>
        </thead>
        <tbody>
        <tr v-for="item in question" :key="item.name">
          <th scope="row">{{ $t(`category.${item.name}`) }}</th>
          <td class="text-center">{{  item.quantity }}</td>
          <td class="text-center">{{ item.used_at_least_one_time }} ({{  item.quantity ? (Math.round(item.used_at_least_one_time / item.quantity * 100)) : 0 }}%) </td>
          <td class="text-center">{{ item.used_more_then_once }} ({{ item.quantity ? (Math.round(item.used_more_then_once / item.quantity * 100)) : 0 }}%)</td>
          <td class="text-center">{{  item.max_usage }}</td>
        </tr>
        </tbody>
      </table>
      <div v-else class="col-12">
        <div class="spinner-wrapper" >
          <b-spinner></b-spinner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect
  },
  data() {
    return {
      locale: null
    }
  },
  computed: {
    ...mapState({
      question: (state) => state.statistics.question,
      isBusy: (state) => state.statistics.isBusy,
      userLocale: (state) => state.root.user.profile.locale
    }),
    adminLocale: function () {
      return this.$store.getters["root/adminLocale"]
    },
  },
  mounted() {
    this.locale = this.adminLocale.filter(locale => {
      return locale.name === this.userLocale;
    })[0];

    this.getReport();
  },
  beforeDestroy() {
    this.$store.commit('statistics/setQuestion', null);
  },
  methods: {
    clearFilters() {
      this.setDefaultLocale();

      this.getReport();
    },
    setDefaultLocale() {
      return this.locale = this.adminLocale.filter(locale => {
        return locale.name === this.userLocale;
      })[0];
    },
    getReport() {
      const locale = this.locale ? this.locale.name : 'pl';

      this.$store.dispatch('statistics/getQuestion', locale);
    }
  }
}
</script>
